import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { getAdminAccess } from './adminAccess'

export default function BuiltinSkillsAdminRoute() {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  if (getAdminAccess(user).builtinSkills) return <Outlet />
  return <Navigate to="/dashboard" replace />
}
